$(document).ready(function () {
  /*
   * checkbox checked
   */
  $(document).on("click", ".chkboxpop.none", function (e) {
    e.preventDefault();
    $(this).addClass("active");
    $(this).removeClass("none");
    $("button.block-right.agree").addClass("active");
    if ($(".block-right.agree.active")[0]) {
      $(".block-right.agree.active").removeAttr("disabled");
    }
  });

  $(document).on("click", ".chkboxpop.active", function (e) {
    e.preventDefault();
    $(this).addClass("none");
    $(this).removeClass("active");
    $("button.block-right.agree").removeClass("active");
    $(".block-right.agree.none").attr("disabled", "disabled");
  });

  var imagep = document.getElementById("image_cropped_preview");

  /*
   * customize button
   */
  $(document).on("click", ".customise_button", function () {
    /* Skip if Bundy Bundle - handled by bundy_bundle_customizer.js */
    if ($(".popup_bundy_customizer")[0]) { return; }
    /* Bags are B2B-only — block popup for guests/DTC users */
    if (window.b2bBagSize && !window.b2bCompanyName) { return; }

    /* bottle-size variant sync */
    if ($(".innerothervar.bottle-size")[0]) {
      var cytyval = $('#ProductSelect-option-1').val();
      var lcses = cytyval.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "").replace(/^-/, "");
      setTimeout(function() {
        var $select = $('.othervariants');
        $select.val(lcses);
        $select[0].dispatchEvent(new Event('change', { bubbles: true }));
      }, 300);
    }

    var isWine = !!$(".main_wine")[0];

    $('.gallery_name_front, .gallery_name_back').html('');
    if (!isWine) {
      $('.outerinner_logo_designs_content').removeClass('active');
      $('.back_outer').removeClass('hide');
    }
    $(".inner_logo_designs_content").removeClass("active");
    if (isWine) { $('.family, .back_family, .mothersday, .back_mothersday').addClass('hide'); }
    $(".animal, .line, .sports, .travel, .nature, .weekend, .back_sports").addClass("hide");
    if (isWine) { $(".back_image").addClass("active"); }
    else        { $(".back_image").removeClass("active"); }

    $("#inverseCheckbox, #backinverseCheckbox").prop("checked", false)
      .attr("disabled", "disabled").css("display", "none");
    $(".inverse_color, .s1").css("display", "none");
    $(".left_image_customize").removeClass("both_textactive");

    var rghtbox = $(".popup_box .eright_section_cutomise").html();
    $("body").addClass("customizer_active");
    $(".popup_pd_customizer").addClass("active");
    $(".upprrig").html(rghtbox);
    var checkval = $(".js-color-swatch:checked").val();
    if (checkval) {
      var colo = checkval.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "").replace(/^-/, "");
      $("." + colo).trigger("click");
      $(".variant_id").attr("data-variant", $(".sw_" + colo).attr("data-varinatid"));
    }

    $(".uploadingimg").removeAttr("src");
    $(".logo_img_gal").attr("src", "");
    $(".text_uploaded .cstm_textup").html("");
    $(".addtocart_box").addClass("hide");
    $(".edit_front_tab, .edit_back_tab").addClass("hide").removeClass("active");
    $(".front_tab, .back_tab").removeClass("hide");
    if (isWine) {
      $(".front_tab").removeClass("active");
      $(".back_tab").addClass("active");
    } else {
      $(".front_tab").addClass("active");
      $(".back_tab").removeClass("active");
    }
    $(".text_ctent").html("");
    $("#design-text").val("");
    $(".inner_text_design_content").removeClass("active");
    $(".left_image_customize").removeClass("both_active");

    $(".font_sstyle_front, .font_sstyle_back").html("");
    $(".front_image_url, .back_image_url").html("");
    $(".front_uploaded_content, .back_uploaded_content").html("");
    $(".downloadhtml").removeAttr("href").removeAttr("download");
    $(".font_items").removeClass("active");
    $(".font_items.font-Roboto").addClass("active");
    $("#customize_chk-label").removeClass("active").addClass("none");
    $(".block-right").removeClass("active").attr("disabled", "disabled");

    var fontClasses = "font-Socialist font-Roboto font-Manderley font-Crosterian font-Whiphand";
    $(".front_image .cstm_textup").removeClass(fontClasses).addClass("font-Roboto");
    if (isWine) { $(".back_image .cstm_textup").removeClass(fontClasses).addClass("font-Roboto"); }
    $("#design-text").removeClass(fontClasses).addClass("font-Roboto");
    $(".conva_imgs").css("display", "none");

    /* Hide the "also add back" button on fresh open */
    $(".also_add_back_btn").addClass("hide");

    /* color texture */
    var selected_colonam = $(".inner_varinat .color_items.active").attr("data-color");
    if (isWine) {
      var base64 = $("#colo64_" + selected_colonam).attr("src");
      if ($(".innerothervar.bottle-size")[0]) {
        var nev = $('.othervariants').val();
        var newitem = selected_colonam - nev;
        var base64k = $("#colo64_" + newitem).attr("src");
        $(".cstm_textup").css("background-image", 'url("' + base64k + '")');
      } else {
        $(".cstm_textup").css("background-image", 'url("' + base64 + '")');
      }
      $(".front_image").removeClass("active");
    } else if (selected_colonam) {
      var base64 = $("#colo64_" + selected_colonam).attr("src");
      if ($(".innerothervar.bottle-size")[0]) {
        var nev = $('.othervariants').val();
        var newitem = selected_colonam + "-" + nev;
        var base64k = $("#colo64_" + newitem).attr("src");
        $(".cstm_textup").css("background-image", 'url("' + base64k + '")');
      } else {
        $(".cstm_textup").css("background-image", 'url("' + base64 + '")');
      }
    }
    $(".back_tab").removeAttr("disabled");

    setTimeout(function() {
      var checkdis = $('.customizer_variant .color_items.active').attr('data-gallery');
      if (typeof checkdis === 'undefined') {
        checkdis = $('.popup_pd_customizer').attr('data-disable-gallery');
      }
      if (checkdis == "true") {
        $('.customize-item.logo_design').hide();
      } else {
        $('.customize-item.logo_design').show();
      }
      var $fallback = $('.colovarinatns_texture .no-color-fallback');
      if ($fallback.length) {
        var frontImg = $fallback.attr('data-front');
        var backImg = $fallback.attr('data-back');
        var variantId = $fallback.attr('data-varinatid');
        var textureImg = $('#colo64_no-color-fallback').attr('src');
        if (frontImg) { $('.main_front_image').attr('src', frontImg); }
        if (backImg) { $('.main_back_image').attr('src', backImg); }
        if (variantId) { $('.variant_id').attr('data-variant', variantId); }
        if (textureImg) { $('.cstm_textup').css('background-image', 'url("' + textureImg + '")'); }
        $('.front_image').addClass('active');
        $('.front_tab').addClass('active');
      }
    }, 500);
  });

  /*
   * variant on changes
   */
  $(document).on("click", ".customizer_variant .color_items", function () {

        var checkdisa = $(this).attr('data-gallery');
if(checkdisa =="true"){
  $('.customize-item.logo_design').hide();
}else{
   $('.customize-item.logo_design').show();
}


    $(".customizer_variant .color_items").removeClass("active");
    $(this).addClass("active");
    $(".coolor_name").removeClass("active");
    var selectedVar = $("span.color_items.active");
    selectedVar
      .parents(".customizer_variant")
      .find(".coolor_name")
      .addClass("active");

    if ($(".color_items.product_soldout.active")[0]) {
      $(".custom_addtocart").attr("disabled", "disabled");
      $(".custom_addtocart").html("Sold Out");
    } else {
      $(".custom_addtocart").removeAttr("disabled");
      $(".custom_addtocart").html("ADD TO CART");
    }

    var currentclor = $(this).attr("data-color");
    var current_id = $(".sw_" + currentclor).attr("data-varinatid");
    $(".product_details .variant_id").attr("data-variant", current_id);
    var currentFrontImage = $(".sw_" + currentclor).attr("data-front");
    var CurrentBackImage = $(".sw_" + currentclor).attr("data-back");
    // $(this).attr('data-varinat',current_id);
    $(".main_front_image").attr("src", currentFrontImage);
    $(".main_back_image").attr("src", CurrentBackImage);

    /* checkselectcolortextureimga*/
    var selected_colonam1 = $(".inner_varinat .color_items.active").attr(
      "data-color"
    );
    var base641 = $("#colo64_" + selected_colonam1).attr("src");
    $(".cstm_textup").css("background-image", 'url("' + base641 + '")');
  });

  /*
   * close customize
   */
  $(document).on("click", ".close_customize", function () {
    
    $(".popup_pd_customizer").removeClass("active");
    $(".review_design_uploadimg").removeClass("active");
    $(".input-options").removeClass("hide");
    $("body").removeClass("customizer_active");
    $(".cancle_btn").addClass("hide");
    $(".accept_btn").addClass("hide");
    $(".clear_btn").removeClass("hide");
    $(".preview_btn").removeClass("hide");

    $(".fileinput").val("");
    $("#preview_img").removeAttr("src");
    $("#cropped_image").removeAttr("src");
    $(".uploadingimg").removeAttr("src");
    $(".text_uploaded .cstm_textup").html("");

    $(".design_uplod").removeClass("active");
    $(".selected_design_box").removeClass("active");
    $(".inner_logo_designs_content").removeClass("active");
    $(".inner_text_design_content").removeClass("active");
    $(".customize-selection").removeClass("hide");

    $(".front_text_preview").addClass("hide");
    $(".back_text_preview").addClass("hide");
    $(".front_text_preview").removeClass("active");
    $(".back_text_preview").removeClass("active");
    $(".front_image").removeClass("hide");
    $(".front_image").addClass("active");

    $(".selected_design_box").removeClass("active");
    $(".inner_logo_designs_content").removeClass("active");
    $(".inner_text_design_content").removeClass("active");
    $(".button_tabs .tab_items").removeClass("active");
    $(".front_tab").addClass("active");
    $(".back_tab").attr("disabled", "disabled");
    $(".edit_front_tab ").addClass("hide");
    $(".edit_back_tab ").addClass("hide");
    $(".also_add_back_btn").addClass("hide");
    // Reset B2B panel state if active
    if (typeof window.b2bResetPanel === 'function') { window.b2bResetPanel(); }
  });

  /*
   * buttons tab
   */
  $(document).on("click", ".button_tabs .tab_items", function () {
    /* Don't handle clicks on the "also add back" button here */
    if ($(this).hasClass('also_add_back_btn')) return;

    $("#design-text").val("");
    $(".tab_items").removeClass("active");
    $(this).addClass("active");
    setTimeout(function () {
      if ($(".front_tab.tab_items.active")[0]) {
        // if text active
        if ($(".inner_text_design_content.active")[0]) {
          $("#design-text").val("");
          $(".front_text_preview").addClass("active");
          $(".front_text_preview").removeClass("hide");
          $(".back_text_preview").removeClass("active");
          $(".back_text_preview").addClass("hide");
          $(".front_image").removeClass("active");
          $(".back_image").removeClass("active");
          var front_textvl = $(".front_image .cstm_textup").html();
          $("#design-text").val("");
        } else if ($(".selected_design_box.active")[0]) {
          $(".uploadingimg .resizable").removeClass("hide");
          $(".front_image").addClass("active");
          $(".back_image").removeClass("active");
          $("#inverseCheckbox").css("display", "inline");
          $(".s1").css("display", "inline");
          $("#backinverseCheckbox").css("display", "none");
          $(".s2").css("display", "none");
        } else {
          $(".front_image").addClass("active");
          $(".back_image").removeClass("active");
        }
      }
      if ($(".back_tab.tab_items.active")[0]) {
        // if text active
        if ($(".inner_text_design_content.active")[0]) {
          $(".back_tab").removeAttr("disabled");
          $(".back_text_preview").addClass("active");
          $(".back_text_preview").removeClass("hide");
          $(".front_text_preview").removeClass("active");
          $(".front_text_preview").addClass("hide");
          $(".front_image").removeClass("active");
          $(".back_image").removeClass("active");
          var front_textv2 = $(".back_image .cstm_textup").html();
          $("#design-text").val("");
        } else if ($(".selected_design_box.active")[0]) {
          $(".uploadingimg .resizable").removeClass("hide");
          $(".back_image").addClass("active");
          $(".front_image").removeClass("active");
          $("#inverseCheckbox").css("display", "none");
          $(".s1").css("display", "none");
          $("#backinverseCheckbox").css("display", "inline");
          $(".s2").css("display", "inline");
        } else {
          $(".front_image").removeClass("active");
          $(".back_image").addClass("active");
        }
      }
    }, 1000);
  });

  /* logo section*/

  $(document).on("click", ".logo_design", function () {
    $(".customize-selection").addClass("hide");
    $('.family').addClass('hide');
    $('.back_family').addClass('hide');
    $('.mothersday').addClass('hide');
    $('.back_mothersday').addClass('hide');
    $(".selected_design_box").removeClass("active");
    $(".inner_selected_design.design_uplod.customization-section").removeClass(
      "active"
    );
    $(".inner_logo_designs_content").addClass("active");

    $(".inner_logo_designs_content .back_logo").removeAttr("style");
    $(".inner_logo_designs_content .logos_content").removeAttr("style");
    $(".inner_logo_designs_content .logo_gallery").removeAttr("style");
    $(".gallery_nav_design .preview_btn").removeClass("hide");
    $(".gallery_nav_design .clear_btn").removeClass("hide");
    $(".front_tab").removeClass("hide");
    $(".back_tab").removeClass("hide");
    $(".edit_front_tab").addClass("hide");
    $(".edit_back_tab").addClass("hide");
    $(".color_customize_variants").removeAttr("style");
    $(".inner_gallerry_wraper.animal_gallery").removeClass("hide");
    $(".inner_gallerry_wraper.sports_gallery").removeClass("hide");
    $(".inner_gallerry_wraper.line_gallery").removeClass("hide");
     $(".inner_gallerry_wraper.nature_gallery").removeClass("hide");
    $(".inner_gallerry_wraper.weekend_gallery").removeClass("hide");
    $(".inner_gallerry_wraper.travel_gallery").removeClass("hide");
    $(".inner_gallerry_wraper.family_gallery").removeClass("hide");
    $(".inner_gallerry_wraper.mothersday_gallery").removeClass("hide");

  });

  /* logo details on click*/
  $(document).on("click", ".logo-item-detail img", function () {
    $(".logo-item-detail .image").removeClass("active");
    $(this).parent(".image").addClass("active");
    $(".gallery_nav_design .preview_btn").removeAttr("disabled");
    $(".gallery_nav_design .clear_btn").removeAttr("disabled");
if ($(this).parents('.outerinner_logo_designs_content').hasClass('active')) {
 
     $(".outergallery_nav_design .preview_btn").removeAttr("disabled");
    $(".outergallery_nav_design .clear_btn").removeAttr("disabled");
}
    var csrc = $(this).parent(".image").attr("data-texture");
    $(".edit_front_tab").addClass("hide");
    $(".edit_back_tab").addClass("hide");
    $(".front_tab").removeClass("hide");
    $(".back_tab").removeClass("hide");
    var logoName = $(this).parents('.logo-item-detail').find('.prepared-item-title').html();
    /* front src*/
    if ($(".front_tab.tab_items.active")[0]) {
      $('.gallery_name_front').html(logoName);
      $("#imageCanvas").removeAttr("width");
      $("#imageCanvas").removeAttr("height");
      $("#inverseCheckbox").attr("disabled", "disabled");
      $("#uploaded-image").removeAttr("src");
      $(".front_image_url").html(csrc);
      // $(".font_sstyle_front").html("");
      $(".front_image .resizable").addClass("hide");
      // $(".front_image .text_uploaded").addClass("hide");
      $(".front_image .resizable").removeClass("active");
      // $(".front_image .text_uploaded").removeClass("active");
      $(".front_image .logo_img img.logo_img_gal").attr("src", csrc);
      $(".front_image_invert").html("No");
      $(".front_image .logo_img").removeClass("hide");
      $(".front_image .logo_img").removeClass("active");
      $(".front_image .logo_img_gal").removeClass("hide");

      var fronthtml1 = $(".front_image .cstm_textup").html();
      if (fronthtml1 != "" && fronthtml1 != " ") {
        $(".front_image .text_uploaded").removeClass("hide");
        $(".front_image .text_uploaded").addClass("active");
        $(".front_image").addClass("both_textactive");
      } else {
        $(".front_image").removeClass("both_textactive");
      }
    }
    // back tabs
    if ($(".back_tab.tab_items.active")[0]) {
        $('.gallery_name_back').html(logoName);
      $("#imageCanvasback").removeAttr("width");
      $("#imageCanvasback").removeAttr("height");
      $("#buploaded-image").removeAttr("src");
      $("#backinverseCheckbox").attr("disabled", "disabled");
      $(".back_image_url").html(csrc);
      // $(".font_sstyle_back").html("");
      $(".back_image .resizable").addClass("hide");
      $(".back_image .resizable").removeClass("active");
      // $(".back_image .text_uploaded").addClass("hide");
      $(".back_image .logo_img img.logo_img_gal").attr("src", csrc);
      $(".back_image_invert").html("No");
      $(".back_image .logo_img").removeClass("hide");
      $(".back_image .logo_img_gal").removeClass("hide");

      var backhtml1 = $(".back_image .cstm_textup").html();
      if (backhtml1 != "" && backhtml1 != " ") {
        $(".back_image .text_uploaded").removeClass("hide");
        $(".back_image .text_uploaded").addClass("active");
        $(".back_image").addClass("both_textactive");
      } else {
        $(".back_image").removeClass("both_textactive");
      }
    }
  });

  $(document).on("click", ".back_logo", function () {
    $(".inner_logo_designs_content").removeClass("active");
    $(".customize-selection").removeClass("hide");
    $(".animal").addClass("hide");
    $(".sports").addClass("hide");
    $(".line").addClass("hide");
    $(".family").addClass("hide");
    $(".mothersday").addClass("hide");
    $(".addtocart_box").addClass("hide");
  });

  /*
   * text upload section
   */
  $(document).on("click", ".text_upload", function () {
    $(".text_nav_design .clear_btn").removeClass("hide");
    $(".text_nav_design .preview_btn ").removeClass("hide");
    $(".customize-selection").addClass("hide");
    $(".back_text").removeAttr("style");
    $(".text_font_section").removeAttr("style");
    $(".design-text").val("");
    $(".selected_design_box").removeClass("active");
    $(".inner_selected_design.design_uplod.customization-section").removeClass(
      "active"
    );
    $(".inner_logo_designs_content").removeClass("active");
    $(".inner_text_design_content").addClass("active");
    $(".front_image").removeClass("active");
    $(".back_image").removeClass("active");
    $(".edit_front_tab").addClass("hide");
    $(".edit_back_tab").addClass("hide");
    $(".front_tab").addClass("hide");
    $(".front_tab").removeClass("hide");
    $(".back_tab").removeClass("hide");

    if ($(".back_tab.tab_items.active")[0]) {
      $(".front_text_preview").removeClass("active");
      $(".front_text_preview").addClass("hide");
      $(".back_text_preview").removeClass("hide");
      $(".back_text_preview").addClass("active");
      $(".text_ctent").hide();
    }
    if ($(".front_tab.tab_items.active")[0]) {
      $(".front_text_preview").removeClass("hide");
      $(".front_text_preview").addClass("active");
      $(".back_text_preview").removeClass("active");
      $(".back_text_preview").addClass("hide");
      $(".text_ctent").hide();
    }

    var checktabs = setInterval(function () {
      if ($(".front_text_preview.active")[0]) {
        var frontd = $(".font_items.active").attr("data-font");
        // $('.text_ctent').addClass('font-'+frontd);
        $(".front_image .cstm_textup").removeClass(
          "font-Roboto font-Socialist font-Manderley font-Crosterian font-Whiphand"
        );
        $(".front_text_preview .text_ctent").removeClass(
          "font-Roboto font-Socialist font-Manderley font-Crosterian font-Whiphand"
        );
        $(".front_image .cstm_textup").addClass("font-" + frontd);
        $(".front_text_preview .text_ctent").addClass("font-" + frontd);
        var chkfttf = $(".front_uploaded_content").html();
        if (chkfttf != "") {
          $(".font_sstyle_front").html(frontd);
        } else {
          $(".font_sstyle_front").html("");
        }

        clearInterval(checktabs);
      }
      if ($(".back_text_preview.active")[0]) {
        var frontds = $(".font_items.active").attr("data-font");
        $(".back_image .cstm_textup").removeClass(
          "font-Roboto font-Socialist font-Manderley font-Crosterian font-Whiphand"
        );
        $(".back_text_preview .text_ctent").removeClass(
          "font-Roboto font-Socialist font-Manderley font-Crosterian font-Whiphand"
        );
        $(".back_image .cstm_textup").addClass("font-" + frontds);
        $(".back_text_preview .text_ctent").addClass("font-" + frontds);

        var chkfttf = $(".back_uploaded_content").html();
        if (chkfttf != "") {
          $(".font_sstyle_back").text(frontds);
        } else {
          $(".font_sstyle_back").text("");
        }

        clearInterval(checktabs);
      }
    }, 100);
  });

  $(document).on("click", ".back_text", function () {
    $("#design-text").val("");
    $(".inner_text_design_content").removeClass("active");
    $(".inner_text_design_content").removeAttr("style");
    $(".back_text").removeAttr("style");
    $(".text_font_section").removeAttr("style");
    $(".customize-selection").removeClass("hide");

    if ($(".front_tab.tab_items.active")[0]) {
      $(".front_text_preview").addClass("hide");
      $(".front_text_preview").removeClass("active");
      $(".back_text_preview").removeClass("active");
      $(".back_text_preview").addClass("hide");
      $(".front_image").addClass("active");
      $(".back_image").removeClass("active");
      $(".front_image .text_uploaded").addClass("active");
      $(".front_image .text_uploaded").removeClass("hide");
      $(".front_image .logo_img").addClass("hide");
      $(".front_image .resizable").addClass("hide");
      $(".front_image .logo_img").removeClass("active");
      $(".front_image .resizable").removeClass("active");
    }
    if ($(".back_tab.tab_items.active")[0]) {
      $(".front_text_preview").addClass("hide");
      $(".front_text_preview").removeClass("active");
      $(".back_text_preview").removeClass("active");
      $(".back_text_preview").addClass("hide");
      $(".back_image").addClass("active");
      $(".front_image").removeClass("active");
      $(".back_image .text_uploaded").addClass("active");
      $(".back_image .text_uploaded").removeClass("hide");
      $(".front_image .logo_img").addClass("hide");
      $(".front_image .resizable").addClass("hide");
      $(".front_image .logo_img").removeClass("active");
      $(".front_image .resizable").removeClass("active");
    }
  });


   var RE_EMOJI = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
// Allow only alphabets, numbers, and space
var RE_SPECIAL = /[^a-zA-Z0-9\s]/g;

$(document).on("keyup keydown change paste input", "#design-text", function (event) {
  if (event.key === "Enter") {
    event.preventDefault();
    return false;
  }

  var $elem = $(this);
  var content = $elem.val();

  // Remove emojis and special characters
  if (RE_EMOJI.test(content) || RE_SPECIAL.test(content)) {
    content = content.replace(RE_EMOJI, '').replace(RE_SPECIAL, '');
    $elem.val(content);
  }

  var dInput = content;
  var valLength = dInput.length;
  var dsize = parseInt($elem.attr("data-size")) || 50;

  if (valLength > dsize) {
    $(".alert.slide-down").removeClass("hide");
    $(".text_nav_design .preview_btn").attr("disabled", "disabled");
  } else {
    $(".alert.slide-down").addClass("hide");
    $(".text_nav_design .preview_btn").removeAttr("disabled");

    if ($(".front_tab.tab_items.active")[0]) {
      $(".front_text_preview .text_ctent").removeAttr("style");
      $(".front_text_preview").removeClass("hide").addClass("active");
      $(".back_text_preview").removeClass("active").addClass("hide");

      $(".front_text_preview .text_ctent, .front_image .cstm_textup, .front_uploaded_content").text(dInput);
      $(".nav_design_buttons.text_nav_design .preview_btn, .nav_design_buttons.text_nav_design .clear_btn").removeAttr("disabled");
      $(".front_image .logo_img").addClass("hide").removeClass("active");

      var frontfondata = $(".font_items.active").attr("data-font");
      $(".font_sstyle_front").text(frontfondata);
      $(".front_image").attr("data-size", valLength);
    }

    if ($(".back_tab.tab_items.active")[0]) {
      $(".back_text_preview .text_ctent").removeAttr("style");
      $(".front_text_preview").removeClass("active").addClass("hide");
      $(".back_text_preview").removeClass("hide").addClass("active");

      $(".back_text_preview .text_ctent, .back_image .cstm_textup, .back_uploaded_content").text(dInput);
      $(".nav_design_buttons.text_nav_design .preview_btn, .nav_design_buttons.text_nav_design .clear_btn").removeAttr("disabled");
      $(".back_image .logo_img").addClass("hide").removeClass("active");

      var backfondata = $(".font_items.active").attr("data-font");
      $(".font_sstyle_back").text(backfondata);
      $(".back_image").attr("data-size", valLength);
    }
  }
});

  $(document).on("click", ".font_items", function () {
    $(".font_items").removeClass("active");
    $(this).addClass("active");
    var currentfont = $(this).attr("data-font");

    /* front font*/
    if ($(".front_tab.tab_items.active")[0]) {
      $(".font_sstyle_front").text(currentfont);
      $("#design-text").removeClass(
        "font-Roboto font-Socialist font-Manderley font-Crosterian font-Whiphand"
      );
      $(".front_image").removeClass(
        "cstm_font_Roboto cstm_font_Socialist cstm_font_Manderley cstm_font-Crosterian cstm_font_Whiphand"
      );
      $(".front_image").addClass("cstm_font_" + currentfont);
      $("#design-text").addClass("font-" + currentfont);

      $(".front_text_preview .text_ctent").removeClass(
        "font-Roboto font-Socialist font-Manderley font-Crosterian font-Whiphand"
      );
      $(".front_text_preview .text_ctent").addClass("font-" + currentfont);
      $(".front_image .cstm_textup").removeClass(
        "font-Roboto font-Socialist font-Manderley font-Crosterian font-Whiphand"
      );
      $(".front_image .cstm_textup").addClass("font-" + currentfont);
    }

    /* back font style*/
    if ($(".back_tab.tab_items.active")[0]) {
      $(".font_sstyle_back").text(currentfont);
      $("#design-text").removeClass(
        "font-Roboto font-Socialist font-Manderley font-Crosterian font-Whiphand"
      );
      $("#design-text").addClass("font-" + currentfont);

      $(".back_image").removeClass(
        "cstm_font_Roboto cstm_font_Socialist cstm_font_Manderley cstm_font-Crosterian cstm_font_Whiphand"
      );
      $(".back_image").addClass("cstm_font_" + currentfont);
      $(".back_text_preview .text_ctent").removeClass(
        "font-Roboto font-Socialist font-Manderley font-Crosterian font-Whiphand"
      );
      $(".back_text_preview .text_ctent").addClass("font-" + currentfont);
      $(".back_image .cstm_textup").removeClass(
        "font-Roboto font-Socialist font-Manderley font-Crosterian font-Whiphand"
      );
      $(".back_image .cstm_textup").addClass("font-" + currentfont);
    }
  });

  $(document).on("click", ".add", function () {
    $(this)
      .prev()
      .val(+$(this).prev().val() + 1);
  });

  $(document).on("click", ".sub", function () {
    if ($(this).next().val() > 1) {
      if ($(this).next().val() > 1)
        $(this)
          .next()
          .val(+$(this).next().val() - 1);
    }
  });

  $(document).on("click", ".custom_addtocart", function () {
    console.log('[ATC] custom_addtocart clicked');
    $(".cstmizer_addtocart_popup").addClass("active");
    var ftexthtml = $(".front_image .cstm_textup").html();
    var btexthtml = $(".back_image .cstm_textup").html();
    /* logo */
  });

  $(document).on("click", ".close_adtc", function () {
    $(".cstmizer_addtocart_popup").removeClass("active");
  });

  $(document).on("click", ".block_close", function () {
    $(".cstmizer_addtocart_popup").removeClass("active");
  });

  /**
   * ═══════════════════════════════════════════════════════════════════
   * ADD TO CART HANDLER — FIXED PRICING & CONTENT DETECTION
   * ═══════════════════════════════════════════════════════════════════
   *
   * Key fixes:
   * 1. Use _hasContent() helper for reliable side detection
   * 2. Trim whitespace and treat " " (single space default) as empty
   * 3. Treat "N/A" as empty for image URLs
   * 4. Ensure customQty correctly counts sides (1 for one side, 2 for both)
   */
  $(document).on("click", "button.block-right.agree.active", function (e) {
    console.log('[ATC] agree button clicked');
    e.preventDefault();
    var swatchname = $(".coolor_name.active").html();
    var gallery_name_front = $('.gallery_name_front').html();
    var gallery_name_back = $('.gallery_name_back').html();
    var product_title = $(".left_image_customize").attr("data-title");
    var pricemoney = $(".left_image_customize").attr("data-moncurreny");
    var pricewithoutcurrency = $(".left_image_customize").attr("data-price");
    var currencyf = $(".left_image_customize").attr("data-cur");
    var qty = $(".qty_custom").val();
    var priceplus1 = 0;
    var priceplus2 = 0;
    var priceplus3 = 0;
    var priceplus4 = 0;

    var eachprice1 = "";
    var eachprice2 = "";
    var eachprice3 = "";
    var eachprice4 = "";

    var qtycustomized1 = 0;
    var qtycustomized2 = 0;
    var qtycustomized3 = 0;
    var qtycustomized4 = 0;
    var customized_pd = parseInt($(".customized_product").attr("data-id"));
    var var_id = parseInt($(".variant_id").attr("data-variant"));
    var customized_img = $(".customized_product").attr("data-img");
    var frntttxt = "";
    var backtexxt = "";
    var frontcheck = false;
    var backcheck = false;

    /**
     * FIXED: Use trimmed content and treat single-space default as empty.
     * The .cstm_textup span defaults to " " (single space) in the Liquid template.
     * The .front_uploaded_content / .back_uploaded_content are cleared to "" on popup open
     * but may still be empty or whitespace-only.
     */
    var fronttext = $.trim($(".front_uploaded_content").text());
    if (fronttext !== "" && fronttext !== "N/A") {
      qtycustomized1 = 1;
      priceplus1 = pricewithoutcurrency;
      eachprice1 = pricemoney;
      frntttxt = fronttext;
      frontcheck = true;
    }

    var backtext = $.trim($(".back_uploaded_content").text());
    if (backtext !== "" && backtext !== "N/A") {
      qtycustomized2 = 1;
      priceplus2 = pricewithoutcurrency;
      eachprice2 = pricemoney;
      backtexxt = backtext;
      backcheck = true;
    }

    var frontinvert = "";
    var backinvert = "";

    var front_image_invert = $(".front_image_invert").html();
    if (front_image_invert != "") {
      frontinvert = front_image_invert;
    }

    var back_image_invert = $(".back_image_invert").html();
    if (back_image_invert != "") {
      backinvert = back_image_invert;
    }

    fronturlimage = "";
    backurlimage = "";

    /**
     * FIXED: Treat "N/A" as empty for image URLs.
     * The theme layout initializes these to "N/A".
     */
    var fronturl = $.trim($(".front_image_url").text());
    if (fronturl !== "" && fronturl !== "N/A") {
      fronturlimage = fronturl;
      qtycustomized3 = 1;
      priceplus3 = pricewithoutcurrency;
      eachprice3 = pricemoney;
      frontcheck = true;
    }

    var backurl = $.trim($(".back_image_url").text());
    if (backurl !== "" && backurl !== "N/A") {
      backurlimage = backurl;
      qtycustomized4 = 1;
      priceplus4 = pricewithoutcurrency;
      eachprice4 = pricemoney;
      backcheck = true;
    }


    /** B2B: override DTC image vars if b2b_upload_customizer.js has data */
    var _b2b = window.b2bSideData || { front: { filename: '', rotated: false }, back: { filename: '', rotated: false } };
    var b2bFront = _b2b.front.cdnUrl || _b2b.front.filename;
    var b2bBack  = _b2b.back.cdnUrl  || _b2b.back.filename;
    var isB2B    = !!window.b2bSideData;
    if (b2bFront) {
      fronturlimage = b2bFront;
      qtycustomized3 = 1;
      priceplus3 = pricewithoutcurrency;
      eachprice3 = pricemoney;
      frontcheck = true;
    }
    if (b2bBack) {
      backurlimage = b2bBack;
      qtycustomized4 = 1;
      priceplus4 = pricewithoutcurrency;
      eachprice4 = pricemoney;
      backcheck = true;
    }

    var totalamount =
      parseFloat(priceplus1) +
      parseFloat(priceplus2) +
      parseFloat(priceplus3) +
      parseFloat(priceplus4);
    var customQty =
      parseInt(qtycustomized1) +
      parseInt(qtycustomized2) +
      parseInt(qtycustomized3) +
      parseInt(qtycustomized4);

    /* Debug logging for pricing verification */
    console.log("[ATC] frontcheck:", frontcheck, "backcheck:", backcheck);
    console.log("[ATC] fronttext:", JSON.stringify(fronttext), "backtext:", JSON.stringify(backtext));
    console.log("[ATC] fronturl:", JSON.stringify(fronturl), "backurl:", JSON.stringify(backurl));
    console.log("[ATC] customQty:", customQty, "totalamount:", totalamount);

    var frontfont = "";
    var font_sstyle_front = $.trim($(".font_sstyle_front").text());
    if (font_sstyle_front !== "" && font_sstyle_front !== "N/A") {
      frontfont = font_sstyle_front;
    }
    var backfont = "";
    var font_sstyle_back = $.trim($(".font_sstyle_back").text());
    if (font_sstyle_back !== "" && font_sstyle_back !== "N/A") {
      backfont = font_sstyle_back;
    }

    // Unique cross-reference ID shared by main product and its engraving SKU
    var custId = Date.now().toString(36);

    // Build all customisation properties onto the main product
    var custProps = {
      _customised_product: "yes",
      "_cust_id": custId,
    };

    if (!isB2B) {
      if (frontcheck) {
        custProps["FRONT ENGRAVING"]          = product_title + "-" + swatchname;
        custProps["FRONT NAME"]               = frntttxt;
        custProps["FRONT FONT"]               = frontfont;
        custProps["FRONT IMAGE"]              = fronturlimage;
        custProps["FRONT IMAGE PRICE"]        = eachprice3;
        custProps["FRONT GALLERY IMAGE NAME"] = gallery_name_front;
        custProps["_FRONT IMAGE INVERT"]      = frontinvert;
      }
      if (backcheck) {
        custProps["BACK ENGRAVING"]           = product_title + "-" + swatchname;
        custProps["BACK NAME"]                = backtexxt;
        custProps["BACK FONT"]                = backfont;
        custProps["BACK IMAGE"]               = backurlimage;
        custProps["BACK IMAGE PRICE"]         = eachprice4;
        custProps["BACK GALLERY IMAGE NAME"]  = gallery_name_back;
        custProps["_BACK IMAGE INVERT"]       = backinvert;
      }
    } else {
      if (frontcheck) {
        custProps["_B2B FRONT ENGRAVING"]     = product_title + "-" + swatchname;
        custProps["B2B FRONT NAME"]           = frntttxt;
        custProps["B2B FRONT FONT"]           = frontfont;
        custProps["B2B FRONT IMAGE"]          = b2bFront;
        custProps["_B2B FRONT IMAGE PRICE"]   = eachprice3;
        custProps["_B2B FRONT IMAGE ROTATED"] = _b2b.front.rotated ? "yes" : "no";
        custProps["_B2B FRONT IMAGE SCALE"]   = Math.round((_b2b.front.scale || 1) * 100);
        custProps["B2B FRONT FINISH"]         = _b2b.front.finish || 'metallic';
      }
      if (backcheck) {
        custProps["_B2B BACK ENGRAVING"]      = product_title + "-" + swatchname;
        custProps["B2B BACK NAME"]            = backtexxt;
        custProps["B2B BACK FONT"]            = backfont;
        custProps["B2B BACK IMAGE"]           = b2bBack;
        custProps["_B2B BACK IMAGE PRICE"]    = eachprice4;
        custProps["_B2B BACK IMAGE ROTATED"]  = _b2b.back.rotated ? "yes" : "no";
        custProps["_B2B BACK IMAGE SCALE"]    = Math.round((_b2b.back.scale || 1) * 100);
        custProps["B2B BACK FINISH"]          = _b2b.back.finish || 'metallic';
      }
    }

    var items = [];

    // Item 1: main product — carries all customisation properties
    items.push({
      id: var_id,
      quantity: qty,
      properties: custProps,
    });

    // Item 2: engraving SKU — price carrier only, hidden in drawer
    if (customQty > 0) {
      items.push({
        id: customized_pd,
        quantity: customQty,
        properties: {
          "_Customised Product": "yes",
          "_cust_id": custId,
        },
      });
    }

    console.log('[ATC] items being added to cart:', JSON.stringify(items, null, 2));
    $(".block-right").html("Loading....");
    setTimeout(function () {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          items: items,
        },
        dataType: "json",
        success: function (response) {
          // Open B2B cart drawer; fall back to old trigger if drawer not loaded
          if (window.openCartDrawer) {
            window.openCartDrawer();
          } else {
            $(
              ".js-drawer-open-button-right .material-icons-outlined"
            ).trigger("click");
          }
          $(".cstmizer_addtocart_popup ").removeClass("active");
          $(".block-right").html("ACCEPT");
          $(".cstmizer_addtocart_popup").removeClass("active");
          $(".popup_pd_customizer").removeClass("active");
          $(".left_image_customize").removeClass("both_active");
          $(".back_image").removeClass("active");
          $(".logo_img").addClass("hide");
          $(".cstm_textup").html("");
          $(".front_text_preview").addClass("hide");
          $(".back_text_preview").addClass("hide");
          $(".front_text_preview").removeClass("hide");
          $(".back_text_preview").removeClass("hide");
          $(".customize-selection").removeClass("hide");
          $(".selected_design_box").removeClass("active");
          $(".inner_logo_designs_content").removeClass("active");
          $(".inner_text_design_content").removeClass("active");
          $('.outerinner_logo_designs_content').removeClass("active");
          $('.back_outer').removeClass("hide");
          $(".design_uplod").removeClass("active");
          $(".front_text_preview").addClass("hide");
          $(".back_text_preview").addClass("hide");
          $(".conva_imgs").css("display", "none");
          $(".also_add_back_btn").addClass("hide");
          // Clear B2B state after successful cart add
          $('.inner_b2b_design_content').removeClass('active');
          if (window.b2bSideData) {
            window.b2bSideData.front = { state: 'init', filename: '', rotated: false };
            window.b2bSideData.back  = { state: 'init', filename: '', rotated: false };
          }
          $('.b2b_overlay').addClass('hide').removeClass('rotated');
          $('.b2b_overlay_img').attr('src', '');
        },
        error: function (XMLHttpRequest, textStatus) {
          console.error("Error adding products to cart");
        },
      });
    }, 2000);
  });

  /* ── Gallery nav ─────────────────────────────────────────────────── */
  var ALL_GALLERY_TILES = '.animal_gallery, .sports_gallery, .line_gallery, ' +
    '.nature_gallery, .weekend_gallery, .travel_gallery, .family_gallery, .pets_gallery, .mothersday_gallery';
  var galleryDefs = [
    { tile: 'animal_gallery',  content: '.animal',  back: '.back_animal'        },
    { tile: 'sports_gallery',  content: '.sports',  back: '.back_sports'        },
    { tile: 'line_gallery',    content: '.line',    back: '.back_lineart'       },
    { tile: 'nature_gallery',  content: '.nature',  back: '.back_nature'        },
    { tile: 'weekend_gallery', content: '.weekend', back: '.back_weekend'       },
    { tile: 'travel_gallery',  content: '.travel',  back: '.back_nature_travel' },
    { tile: 'family_gallery',     content: '.family',     back: '.back_family'        },
    { tile: 'mothersday_gallery', content: '.mothersday', back: '.back_mothersday'    },
  ];
  galleryDefs.forEach(function(g) {
    $(document).on('click', '.inner_gallerry_wraper.' + g.tile, function() {
      $(ALL_GALLERY_TILES).addClass('hide');
      $('.back_logo').addClass('hide').css('display', 'none');
      $(g.back).removeClass('hide');
      $(g.content + ' .logos_content').css('display', 'block');
      $(g.content + ' .logo_gallery').css('display', 'block');
      $('.addtocart_box').addClass('hide');
      $('.gallery_nav_design .clear_btn, .gallery_nav_design .preview_btn').removeClass('hide');
    });
    $(document).on('click', g.back + '.back_inner', function() {
      $(ALL_GALLERY_TILES).removeClass('hide');
      $('.back_logo').removeClass('hide').css('display', 'flex');
      $(g.content).addClass('hide');
      $(g.back).addClass('hide');
    });
  });

  /* outer fathersday */
  $(document).on('click', '.customize-item.outerline_gallery', function() {
    $('.outerinner_logo_designs_content').addClass('active');
    $('.outerline').removeClass('hide');
    $('.customize-selection').addClass('hide');
  });
  $(document).on('click', '.back_outer.back_btn', function() {
    $('.outerinner_logo_designs_content').removeClass('active');
    $('.customize-selection').removeClass('hide');
    $('.outerline').addClass('hide');
    $('.addtocart_box').addClass('hide');
  });

  /* pets gallery */
  $(document).on('click', '.pets_gallery', function() {
    $(ALL_GALLERY_TILES).addClass('hide');
    $('.back_logo').addClass('hide').css('display', 'none');
    $('.back_pets').removeClass('hide');
    $('.pets, .pets_dogs, .pets_cats').removeClass('hide');
    $('.addtocart_box').addClass('hide');
    $('.gallery_nav_design .clear_btn, .gallery_nav_design .preview_btn').removeClass('hide');
  });
  $(document).on('click', '.back_pets.back_inner', function() {
    $(ALL_GALLERY_TILES).removeClass('hide');
    $('.back_logo').removeClass('hide').css('display', 'flex');
    $('.pets, .pets_dogs, .pets_cats').addClass('hide');
    $('.back_pets').addClass('hide');
  });

  /* pets sub-galleries */
  $(document).on('click', '.pets_dogs', function() {
    $(this).addClass('hide');
    $('.pets_cats').addClass('hide');
    $('.back_pets').addClass('hide');
    $('.back_dog').removeClass('hide');
    $('.dogs').removeClass('hide');
    $('.dogs .logos_content, .dogs .logo_gallery').removeAttr('style');
  });
  $(document).on('click', '.back_dog.back_inner', function() {
    $(this).addClass('hide');
    $('.back_pets').removeClass('hide');
    $('.dogs').addClass('hide');
    $('.pets_cats, .pets_dogs').removeClass('hide');
  });
  $(document).on('click', '.pets_cats', function() {
    $(this).addClass('hide');
    $('.pets_dogs').addClass('hide');
    $('.back_pets').addClass('hide');
    $('.back_cats').removeClass('hide');
    $('.cats').removeClass('hide');
    $('.cats .logos_content, .cats .logo_gallery').removeAttr('style');
  });
  $(document).on('click', '.back_cats.back_inner', function() {
    $(this).addClass('hide');
    $('.back_pets').removeClass('hide');
    $('.cats').addClass('hide');
    $('.pets_cats, .pets_dogs').removeClass('hide');
  });

});
